import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const InvestorsInfoRoot = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  maxWidth: '277px',
  width: '100%',
  paddingRight: theme.spacing(3),
  borderRight: `1px solid ${theme.colors.neutrals.grey8}`,
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    maxWidth: '100%',
    padding: theme.spacing(3),
    borderRadius: theme.borderRadius.small,
    border: `1px solid ${theme.colors.neutrals.grey8}`,
    marginBottom: theme.spacing(3),
  },
}));

export const InvestorsInfoRow = styled.div<{ marginTop?: number }>(({ marginTop }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: marginTop ? `${marginTop}px` : null,
}));

export const InvestorsInfoLabel = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey2,
}));

export const InvestorsHintBox = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  cursor: 'pointer',
  userSelect: 'none',
  alignItems: 'center',
  'svg': {
    display: 'block',
  },
}));
